module.exports = __webpack_public_path__ + "img/ic_32_sport_hockey-active.b894b093.svg";